var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0831 22.4672C29.8313 29.6789 22.1596 33.6997 14.9479 31.4479C7.73617 29.196 3.71538 21.5243 5.96721 14.3126C8.21903 7.10091 15.8907 3.08013 23.1025 5.33195C30.3142 7.58377 34.335 15.2555 32.0831 22.4672Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0831 22.4672C29.8313 29.6789 22.1596 33.6997 14.9479 31.4479C7.73617 29.196 3.71538 21.5243 5.96721 14.3126C8.21903 7.10091 15.8907 3.08013 23.1025 5.33195C30.3142 7.58377 34.335 15.2555 32.0831 22.4672Z",
    fill: "url(#paint0_linear_5854_2936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0841 5.39049C15.9047 3.14878 8.26746 7.15151 6.02575 14.3308C3.78403 21.5102 7.78676 29.1474 14.9661 31.3892C22.1454 33.6309 29.7827 29.6281 32.0244 22.4488C34.2661 15.2695 30.2634 7.6322 23.0841 5.39049ZM5.90849 14.2942C8.17042 7.05014 15.8766 3.0113 23.1207 5.27324C30.3648 7.53517 34.4036 15.2413 32.1417 22.4854C29.8797 29.7295 22.1736 33.7684 14.9295 31.5064C7.68539 29.2445 3.64656 21.5383 5.90849 14.2942Z",
    fill: "url(#paint1_linear_5854_2936)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4345 20.595C12.8024 20.5329 13.151 20.7809 13.213 21.1488C13.3662 22.0573 13.7642 22.9069 14.364 23.6062C14.9639 24.3054 15.7431 24.828 16.6177 25.1176C17.4923 25.4073 18.4293 25.453 19.328 25.25C20.2267 25.047 21.053 24.6029 21.7182 23.9654C21.9876 23.7072 22.4153 23.7163 22.6734 23.9857C22.9316 24.2551 22.9225 24.6828 22.6531 24.941C21.8106 25.7484 20.764 26.3109 19.6257 26.568C18.4875 26.8252 17.3007 26.7672 16.1929 26.4004C15.0851 26.0335 14.0983 25.3716 13.3385 24.486C12.5787 23.6003 12.0747 22.5242 11.8806 21.3735C11.8186 21.0056 12.0665 20.657 12.4345 20.595Z",
    fill: "#232122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6431 19.0338C17.1093 19.0338 19.1085 17.0346 19.1085 14.5684C19.1085 12.1023 17.1093 10.103 14.6431 10.103C12.177 10.103 10.1777 12.1023 10.1777 14.5684C10.1777 17.0346 12.177 19.0338 14.6431 19.0338Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6109 22.1461C27.0771 22.1461 29.0763 20.1469 29.0763 17.6807C29.0763 15.2146 27.0771 13.2153 24.6109 13.2153C22.1447 13.2153 20.1455 15.2146 20.1455 17.6807C20.1455 20.1469 22.1447 22.1461 24.6109 22.1461Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 18.6234C16.2944 18.6234 17.4325 17.4853 17.4325 16.0815C17.4325 14.6776 16.2944 13.5396 14.8906 13.5396C13.4867 13.5396 12.3486 14.6776 12.3486 16.0815C12.3486 17.4853 13.4867 18.6234 14.8906 18.6234Z",
    fill: "url(#paint2_linear_5854_2936)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6532 21.3597C25.0571 21.3597 26.1952 20.2217 26.1952 18.8178C26.1952 17.4139 25.0571 16.2759 23.6532 16.2759C22.2494 16.2759 21.1113 17.4139 21.1113 18.8178C21.1113 20.2217 22.2494 21.3597 23.6532 21.3597Z",
    fill: "url(#paint3_linear_5854_2936)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5854_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.341 11.4798C15.3119 11.4269 15.2019 11.1852 15.1607 11.132C14.7214 10.5651 13.8298 10.2661 12.968 10.6123L12.2332 10.866L14.0275 4.92179C14.114 4.63805 14.0874 4.33186 13.9532 4.06732C13.819 3.80277 13.5877 3.60038 13.3077 3.5025C13.1627 3.4518 13.0089 3.4307 12.8556 3.44047C12.7023 3.45024 12.5524 3.49067 12.415 3.55936C12.2776 3.62806 12.1553 3.72363 12.0555 3.84041C11.9556 3.9572 11.8802 4.09283 11.8337 4.23927L10.958 7.03723L10.8599 7.01059L12.2144 2.7711C12.3114 2.46688 12.2841 2.13668 12.1386 1.85247C11.9931 1.56825 11.7412 1.35306 11.4377 1.2538C11.2857 1.20406 11.1253 1.18498 10.9658 1.19765C10.8063 1.21032 10.6509 1.2545 10.5086 1.32763C10.3663 1.40076 10.2399 1.50139 10.1367 1.62369C10.0336 1.746 9.95568 1.88754 9.9076 2.04014L8.5949 6.19039C8.56943 6.18136 8.54376 6.17315 8.51819 6.16454L9.30689 3.59572C9.30689 3.59572 9.40817 3.26592 9.52462 2.88661C9.61626 2.58815 9.58736 2.26568 9.44411 1.98827C9.30086 1.71087 9.05466 1.5006 8.75825 1.40252C8.45774 1.30312 8.13005 1.32712 7.84722 1.46925C7.5644 1.61139 7.34959 1.86001 7.25002 2.16047L6.09385 5.64901L6.01012 5.60956L6.65108 3.62173C6.73896 3.34478 6.71554 3.04448 6.58577 2.7845C6.45601 2.52452 6.23011 2.32529 5.95595 2.22904C5.68472 2.13377 5.38721 2.14667 5.12526 2.26507C4.8633 2.38347 4.65704 2.59826 4.54935 2.8648C3.84997 4.59523 2.63845 7.27455 2.31027 8.26749C1.51692 10.2566 1.66909 13.1635 3.39204 14.7671C4.07402 15.402 4.91634 15.8388 5.82822 16.0304C6.74011 16.222 7.68699 16.1612 8.56684 15.8544C9.49966 15.5749 9.82545 15.4184 10.1961 15.1797C10.9447 14.6977 12.3314 13.629 13.1727 13.2245C13.6811 12.98 14.3803 12.7564 14.8541 12.6177C14.9681 12.5852 15.0735 12.5277 15.1625 12.4494C15.2515 12.371 15.3219 12.2738 15.3686 12.1647C15.4152 12.0557 15.437 11.9377 15.4322 11.8192C15.4274 11.7007 15.3962 11.5848 15.341 11.4798Z",
    fill: "url(#paint4_linear_5854_2936)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5854_2936",
    x: 0.849609,
    y: 0.193848,
    width: 17.583,
    height: 18.9458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5854_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5854_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5854_2936",
    x1: 14.9577,
    y1: 31.4609,
    x2: 23.1108,
    y2: 5.33267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE932C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08841,
    stopColor: "#E6A236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24156,
    stopColor: "#F1B643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#F9C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63166,
    stopColor: "#FECD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5854_2936",
    x1: 14.9393,
    y1: 31.5195,
    x2: 23.129,
    y2: 5.27393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2A9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28938,
    stopColor: "#FFE09E",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65252,
    stopColor: "#FFD97F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF54",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5854_2936",
    x1: 12.4699,
    y1: 15.3306,
    x2: 17.325,
    y2: 16.8456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#363234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#282425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5854_2936",
    x1: 21.2368,
    y1: 18.0665,
    x2: 26.0918,
    y2: 19.5814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50651,
    stopColor: "#322E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5854_2936",
    x1: 10.4471,
    y1: 15.2113,
    x2: 7.9245,
    y2: 4.49442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.40c4a9c4f3d73f5770a9ebc1ab0ebdac.svg";
export { ForwardRef as ReactComponent };